import * as React from "react";
import { range } from "utils/ArrayUtils";
import padStart from 'string.prototype.padstart';
import Label from "../Label";

class ExpirationDate extends React.Component<any, any> {
  private readonly month: React.RefObject<HTMLSelectElement>;
  private readonly year: React.RefObject<HTMLSelectElement>;

  constructor(props: any){
    super(props);
    this.state = {error: 'Card is expired', showErrors: false, isValid: ''};
    this.month = React.createRef();
    this.year = React.createRef();
  }

  public componentDidMount() {
    this.props.onChange({ target: this.month.current });
    this.props.onChange({ target: this.year.current });
  }

  private onSelect = () => {
    let isValid = this.validate();
    let message = isValid ? '' : 'Card is expired';
    this.setState({error: message, showErrors: true, isValid: isValid ? '1': '' });
    this.props.onChange({ target: this.month.current });
    this.props.onChange({ target: this.year.current });
  };

  public validate(): boolean {
    return new Date() < new Date(`${this.month.current!.value}/1/${this.year.current!.value}`);
  }

  public render() {
    const months = range(1, 12);
    const years = range(new Date().getFullYear(), 38);
    return (
      <div>
        <Label htmlFor="exp_month" showErrors={this.props.showErrors || this.state.showErrors} error={this.state.error}>
          Expiration Date
        </Label>
        <input type="text" className="hidden-input" onInvalid={this.onSelect} required={true} value={this.state.isValid} onChange={()=>{}}/>
        <select
          ref={this.month}
          onChange={this.onSelect}
          name="exp_month">
          {months.map((item, i) => (
            <option key={i}>
              { padStart(item.toString(), 2, 0) }
            </option>
          ))}
        </select>
        <select name="exp_year" onChange={this.onSelect} ref={this.year}>
          {years.map((item, i) => (
            <option value={item} key={i}>
              {item}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default ExpirationDate;



// WEBPACK FOOTER //
// ./src/checkout/fields/creditcard/ExpirationDate.tsx